import { render, staticRenderFns } from "./main.vue?vue&type=template&id=758aa816&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_a2ryrgrddytsl2onh2hza74dqa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\comm\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('758aa816')) {
      api.createRecord('758aa816', component.options)
    } else {
      api.reload('758aa816', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=758aa816&", function () {
      api.rerender('758aa816', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/components/dg-notice/src/main.vue"
export default component.exports